import videojs from "video.js";
import "../vendor/Youtube.js";

$(window).on('load', function () {

    let videoId = 0;
    $('.youtube-video').each(function (e) {
        videoId++;
        const video_src = $(this).data("youtube");
        const autoplay_data = $(this).data("autoplay");
        const playerBox = $(this);

        if (video_src) {
            let autoplaySettings = autoplay_data ? ' autoplay loop muted playsinline ' : '';
            playerBox.html(`
                        <video preload="auto" id="videoJsPlayer${videoId}" class="video-js bg-img vjs-theme-revocit" controls ${autoplaySettings} data-setup='{
                            "disablePictureInPicture": true,
                            "controlBar": {
                                "volumePanel": {
                                    "inline": false,
                                    "vertical": true
                                }
                            },
                            "techOrder": ["youtube"],
                            "sources": [{
                                "type": "video/youtube",
                                "src": "${video_src}"
                            }]
                        }'></video>
                    `);

            const player = videojs(`videoJsPlayer${videoId}`);

            // Attach event listeners for debugging
            // player.on('error', function () {
            //     console.log('Error:', player.error());
            // });
            //
            // player.on('loadedmetadata', function () {
            //     console.log('Metadata loaded for video:', video_src);
            // });
            //
            // player.on('playing', function () {
            //     console.log('Video is playing');
            // });
        }
    })
});